import { call, put, select, takeLatest } from 'redux-saga/effects'
import { setRespPerformByOptions } from '../store/options.actions'
import { getServiceIdSelector } from '../../user/selectors'
import { OptionsService } from '../services/options.service'
import { IOptionsResponse } from '../../../common/common.types'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

export function* getRespPerformByOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getRespPerformByOptions])
    const { entity } = response
    yield put(setRespPerformByOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getRespPerformByOptions() error: ${e}`))
  }
}
export function* getRespPerformByOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getRespPerformByOptions)
}
